import React from 'react';
import { Button, CodeSnippet } from 'carbon-components-react';

const openArcgisOnlineWebMap = (url: string) => {
  window.open(
    `https://www.arcgis.com/home/webmap/viewer.html?url=${encodeURIComponent(
      url
    )}`,
    '_blank'
  );
};

const FeatureLayerURL: React.FC<Props> = ({ url, label }) => {
  return (
    <div className="gis-integration-feature-form bx--form-item bx--text-input-wrapper">
      <div className="gis-integration-feature-url-container">
        <label className="gis-integration-feature-url-label bx--label">
          {label}
        </label>
        <Button
          kind="ghost"
          className="gis-integration-feature-url-btn"
          onClick={() => openArcgisOnlineWebMap(url)}
        >
          View in ArcGIS Online
        </Button>
      </div>
      <div className="bx--text-input__field-outer-wrapper">
        <div className="bx--text-input__field-wrapper">
          <CodeSnippet
            type="single"
            className="gis-integration-feature-url-snippet"
            onClick={() => navigator.clipboard.writeText(url)}
            hideCopyButton={!url}
          >
            {url}
          </CodeSnippet>
        </div>
      </div>
    </div>
  );
};

type Props = {
  url: string;
  label: string;
};

export default React.memo(FeatureLayerURL);
